"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.seoTitlesLookup = exports["default"] = void 0;
var _utils = require("../utils");
var _buildContentfulImageUrl = _interopRequireDefault(require("../utils/build-contentful-image-url"));
var _seoLite = _interopRequireDefault(require("./seo-lite"));
var _image = _interopRequireDefault(require("./image"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var titleFallbacks = {
  person: 'name'
};
var descriptionFallbacks = {
  person: 'shortBio'
};
var seoTitlesLookup = {
  fettle: 'Fettle by SH:24',
  sh24: 'SH:24',
  hep_c_ireland: 'Hepatitis C Home Test',
  hcrg: 'Sexual Health Hub',
  sh24_ireland: 'SH:24',
  bnssg: 'Yuno sexual health'
};
exports.seoTitlesLookup = seoTitlesLookup;
var sh24CanonicalPageTypes = ['helpPost', 'page_v2'];
var createSEOTitle = function createSEOTitle(_ref) {
  var contentType = _ref.contentType,
    fields = _ref.fields,
    currentSite = _ref.currentSite,
    titleSeparator = _ref.titleSeparator;
  var seoTitle = (0, _utils.getProp)(fields, 'seoTitle') || (0, _utils.getProp)(fields, titleFallbacks[contentType] || 'title');
  var seoTitleSuffix = seoTitlesLookup[currentSite];
  if (seoTitleSuffix) return [seoTitle, seoTitleSuffix].join(titleSeparator);
  return seoTitle;
};
var createSEODescription = function createSEODescription(_ref2) {
  var contentType = _ref2.contentType,
    fields = _ref2.fields;
  return (0, _utils.getProp)(fields, 'seoDescription') || (0, _utils.getProp)(fields, descriptionFallbacks[contentType]);
};
var createSEOKeywords = function createSEOKeywords(_ref3) {
  var fields = _ref3.fields;
  return (0, _utils.getProp)(fields, 'seoKeywords') || [];
};
var createSEOImage = function createSEOImage(_ref4) {
  var fields = _ref4.fields;
  var prop = (0, _utils.getProp)(fields, 'seoImage') || (0, _utils.getProp)(fields, 'image');
  if (!prop) return null;
  var image = (0, _image["default"])(prop);
  var width = 828;
  var src = (0, _buildContentfulImageUrl["default"])({
    src: image.src,
    width: width,
    quality: 75
  });
  return {
    src: src || '',
    alt: image.description ? image.description : '',
    width: width
  };
};
var createRobots = function createRobots(_ref5) {
  var fields = _ref5.fields;
  var _createSEOLite = (0, _seoLite["default"])({
      fields: fields
    }),
    noIndex = _createSEOLite.noIndex,
    noFollow = _createSEOLite.noFollow;
  var robots = [];
  if (noFollow) robots.push('nofollow');
  if (noIndex) robots.push('noindex');
  return robots.join(', ');
};
var createCanonicalSite = function createCanonicalSite(_ref6) {
  var contentType = _ref6.contentType,
    site = _ref6.fields.site;
  var sourceSite = 'sh24';
  var NEXT_PUBLIC_SITE = process.env.NEXT_PUBLIC_SITE;
  if (sh24CanonicalPageTypes.includes(contentType) && site.includes(sourceSite)) {
    return sourceSite;
  }
  return NEXT_PUBLIC_SITE;
};
var createSEO = function createSEO(_ref7) {
  var _sys$contentType, _sys$contentType$sys;
  var sys = _ref7.sys,
    fields = _ref7.fields;
  var contentType = sys === null || sys === void 0 ? void 0 : (_sys$contentType = sys.contentType) === null || _sys$contentType === void 0 ? void 0 : (_sys$contentType$sys = _sys$contentType.sys) === null || _sys$contentType$sys === void 0 ? void 0 : _sys$contentType$sys.id;
  var canonicalSite = createCanonicalSite({
    contentType: contentType,
    fields: fields
  });
  var currentSite = process.env.NEXT_PUBLIC_SITE;
  var titleSeparator = ' | ';
  var includeHreflangTags = ['sh24', 'sh24_ireland'].includes(currentSite) && (0, _utils.getProp)(fields, 'includeHreflangTags');
  return {
    id: (0, _utils.getProp)(sys, 'id'),
    canonicalSite: canonicalSite,
    title: createSEOTitle({
      contentType: contentType,
      fields: fields,
      currentSite: currentSite,
      titleSeparator: titleSeparator
    }),
    description: createSEODescription({
      contentType: contentType,
      fields: fields
    }),
    schema: (0, _utils.getProp)(fields, 'seoSchema'),
    robots: createRobots({
      fields: fields
    }),
    keywords: createSEOKeywords({
      fields: fields
    }),
    og: {
      title: createSEOTitle({
        contentType: contentType,
        fields: fields
      }),
      description: createSEODescription({
        contentType: contentType,
        fields: fields
      }),
      image: createSEOImage({
        fields: fields
      })
    },
    includeHreflangTags: includeHreflangTags
  };
};
var _default = createSEO;
exports["default"] = _default;